// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__b4sdn","qrPopup":"styles_qrPopup__jy8JY","qrHeader":"styles_qrHeader__l6O3l","qrCorners":"styles_qrCorners__TGrCv","qrCode":"styles_qrCode__DetUv"};